<template>
    <div>
        <h4>คนรถยืนยันที่จะลาออกใช่หรือไม่</h4>
        <br>
        <div class="row form-group">
            <div class="col-5 text-right">
                <div>คืนเงินประกันให้คนขับ</div>
            </div>
            <div class="col-5">
                <input type="number" placeholder="บาท"
                       v-model="form.insurance_refund"
                       class="form-control">
            </div>
            <div class="col-2">
                <span v-if="money_driver">{{money_driver.insurance - form.insurance_refund | amount}}</span>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-5 text-right">คืนเงินฝากให้กับคนรถ</div>
            <div class="col-5">
                <input type="number" placeholder="บาท"
                       v-model="form.deposit_refund"
                       class="form-control">
            </div>
            <div class="col-2">
                <span v-if="money_driver">{{money_driver.deposit - form.deposit_refund | amount}}</span>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-5 text-right">ปิดยอดค่าผ่อนรถ</div>
            <div class="col-5">
                <input type="number" placeholder="บาท"
                       v-model="form.car_fee_refund"
                       class="form-control">
            </div>
            <div class="col-2">
                <span v-if="money_driver">{{money_driver.car_fee - form.car_fee_refund | amount}}</span>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-5 text-right">ปิดยอดค่าผ่อนค่าหลังคากระบะ</div>
            <div class="col-5">
                <input type="number" placeholder="บาท"
                       v-model="form.car_roof_refund"
                       class="form-control">
            </div>
            <div class="col-2">
                <span v-if="money_driver">{{money_driver.car_roof - form.car_roof_refund | amount}}</span>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-5 text-right">ปิดยอดค่าเสียหาย</div>
            <div class="col-5">
                <input type="number" placeholder="บาท"
                       v-model="form.cost_refund"
                       class="form-control">
            </div>
            <div class="col-2">
                <span v-if="money_driver">{{money_driver.cost - form.cost_refund | amount}}</span>
            </div>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitData"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก</button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
<!--        <pre>{{this.form}}</pre>-->
    </div>
</template>

<script>
    export default {
        name: "DeleteDriverModal",
        props : {
            money_driver : Object
        },
        data(){
          return{
              form : {
                  car_fee_refund : '',
                  deposit_refund : '',
                  insurance_refund : '',
                  car_roof_refund : '',
                  cost_refund : '',
                  user : '',
              }
          }
        },
        methods:{
            submitData(){
                this.$emit("submit",this.form);
            },
            cancelData(){
                this.$emit("submit",false);
            }
        }
    }
</script>

<style scoped>

</style>
